const handleTabsClick = () => {
  const hiddenTabClass = 'calendar__wrapper--hidden';
  const activeButtonClass = 'calendar__top-button--active';

  const buttons = document.getElementsByClassName('calendar__top-button');
  const tabs = document.getElementsByClassName('calendar__wrapper');

  const updateTabs = (buttonIndex) => {
    Array.from(tabs).forEach((tab, tabIndex) => {
      if (buttonIndex === tabIndex) {
        tab.classList.remove(hiddenTabClass);
        buttons[tabIndex].classList.add(activeButtonClass);
      } else {
        tab.classList.add(hiddenTabClass);
        buttons[tabIndex].classList.remove(activeButtonClass);
      }
    });
  };

  Array.from(buttons).forEach((button, index) => {
    button.addEventListener('click', () => updateTabs(index));
  });
};

const CalendarComponent = () => {
  handleTabsClick();
};

export const Calendar = () => {
  $(document).ready(() => CalendarComponent());
};
